module.exports = __webpack_public_path__ + "static/media/win-reward-A12.c11157ed.png";